<ng-container [ngSwitch]="type">
  <awair-warning-icon class="__icon"
                      *ngSwitchCase="ToastType.Alert"
                      [inverse]="true">
  </awair-warning-icon>
  <awair-check-icon class="__icon"
                    *ngSwitchCase="ToastType.Success"
                    [inverse]="true">
  </awair-check-icon>
</ng-container>

<ng-content></ng-content>

<awair-cross-icon class="__close-button"
                  [color]="'#FFFFFF'"
                  [size]="{width: 14, height: 14}"
                  (click)="onClose()">
</awair-cross-icon>
